import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { Container, useTick } from '@pixi/react';
import { useCallback, useEffect, useRef, useState } from 'react';
import { useAppSelector } from '../../../redux/store';
import { isTestEnvironment } from '../../../utils/utils';
import { createInertia, updateInertia } from '../animation/inertia';
import { ActionArrow } from './actionArrow';
export function getSeatYDest(seatY, seatHeight) {
    return seatY - seatHeight / 5;
}
function getInertia(inertia, seatHeight, seatX, seatY, tableAreaWidth, tableAreaHeight) {
    if (seatHeight === undefined ||
        seatX === undefined ||
        seatY === undefined ||
        tableAreaWidth === undefined ||
        tableAreaHeight === undefined) {
        return null;
    }
    return createInertia({
        magnitude: 0,
        i: 0.3,
        k: 0.05,
        currX: inertia ? inertia.currX : tableAreaWidth / 2,
        currY: inertia ? inertia.currY : tableAreaHeight / 2,
        destX: seatX,
        destY: getSeatYDest(seatY, seatHeight),
        xp: inertia ? inertia.xp : undefined,
        yp: inertia ? inertia.yp : undefined
    });
}
export const SingleActionArrowContainer = ({ actionTimerSeatIndex }) => {
    const [isAnimating, setIsAnimating] = useState(true);
    const [isDoneMoving, setIsDoneMoving] = useState(false);
    const tableAreaWidth = useAppSelector((state) => state.gameDimensions.tableAreaDimensions?.w);
    const tableAreaHeight = useAppSelector((state) => state.gameDimensions.tableAreaDimensions?.h);
    const seatWidth = useAppSelector((state) => state.gameDimensions.seatDimensions?.w);
    const seatHeight = useAppSelector((state) => state.gameDimensions.seatDimensions?.h);
    const seatX = useAppSelector((state) => state.gameDimensions.allSeatBounds[actionTimerSeatIndex].x);
    const seatY = useAppSelector((state) => state.gameDimensions.allSeatBounds[actionTimerSeatIndex].y);
    const containerRef = useRef(null);
    const inertiaRef = useRef(getInertia(null, seatHeight, seatX, seatY, tableAreaWidth, tableAreaHeight));
    const animate = useCallback(() => {
        if (!inertiaRef.current || !containerRef.current) {
            setIsAnimating(false);
            return;
        }
        containerRef.current.x = inertiaRef.current.currX;
        containerRef.current.y = inertiaRef.current.currY;
        const inertiaResult = updateInertia(inertiaRef.current);
        inertiaRef.current = inertiaResult.inertia;
        if (inertiaResult.isDone) {
            setIsDoneMoving(true);
            setIsAnimating(false);
        }
    }, []);
    useEffect(() => {
        // Start the arrow moving, (whether or not it is stopped), when the action timer changes, or the dimensions of the table
        // (from a browser window resize) change.
        inertiaRef.current = getInertia(inertiaRef.current, seatHeight, seatX, seatY, tableAreaWidth, tableAreaHeight);
        setIsDoneMoving(false);
        setIsAnimating(true);
    }, [seatHeight, seatX, seatY, tableAreaWidth, tableAreaHeight, animate]);
    useTick(animate, isAnimating);
    if (tableAreaWidth === undefined ||
        tableAreaHeight === undefined ||
        seatWidth === undefined ||
        seatHeight === undefined ||
        actionTimerSeatIndex === undefined) {
        return null;
    }
    return (_jsx(Container, { ref: containerRef, "pixi-data": isTestEnvironment() ? { type: 'action-arrow', seatIndex: actionTimerSeatIndex, isDoneMoving } : null, interactiveChildren: false, children: _jsx(ActionArrow, {}) }));
};
